import React, { useState, useEffect } from 'react';
import styles from "./AdminDashboard.module.css";
import { FaUsers, FaChartLine, FaShoppingCart, FaBell } from 'react-icons/fa';
import { GET } from '../../../../config/api';

const AdminDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState({
        totalUsers: 0,
        activeUsers: 0,
        totalOrders: 0,
        revenue: 0,
        recentActivity: []
    });

    useEffect(() => {
        const fetchUsers = async () => {
            const { data, error, message } = await GET('website/admin/users');
            // data && setUsers(data);
            if (data) {
            setStats({
                totalUsers: data.length,
                activeUsers: data.filter((user) => user.verified).length,
                totalOrders: 456,
                revenue: 78900,
                recentActivity: data.slice(0, 10).map((user) => ({
                    id: user.id,
                    icon: <FaUsers />,
                    title: user.username,
                    time: user.createdAt,
                    verified: user.verified
                }))
            });
        }
            // error && setError(message);
            setLoading(false);
        };

        fetchUsers();
        setLoading(false);
    }, []);

    // const stats.recentActivity = [
    //     {
    //         id: 1,
    //         icon: <FaUsers />,
    //         title: "New user registration",
    //         time: "5 minutes ago"
    //     },
    //     {
    //         id: 2,
    //         icon: <FaShoppingCart />,
    //         title: "New order received",
    //         time: "15 minutes ago"
    //     },
    //     {
    //         id: 3,
    //         icon: <FaChartLine />,
    //         title: "Monthly report generated",
    //         time: "1 hour ago"
    //     },
    //     {
    //         id: 4,
    //         icon: <FaBell />,
    //         title: "System notification",
    //         time: "2 hours ago"
    //     }
    // ];

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>Admin Dashboard</h1>
                <div className={styles.headerActions}>
                    <button className={styles.notificationButton}>
                        <FaBell />
                        <span className={styles.notificationBadge}>3</span>
                    </button>
                </div>
            </header>

            <div className={styles.statsGrid}>
                <div className={`${styles.statCard} ${loading ? styles.loading : ''}`}>
                    <div className={styles.statTitle}>Total Users</div>
                    <div className={styles.statValue}>{stats.totalUsers}</div>
                </div>
                <div className={`${styles.statCard} ${loading ? styles.loading : ''}`}>
                    <div className={styles.statTitle}>Active Users</div>
                    <div className={styles.statValue}>{stats.activeUsers}</div>
                </div>
                <div className={`${styles.statCard} ${loading ? styles.loading : ''}`}>
                    <div className={styles.statTitle}>Total Orders</div>
                    <div className={styles.statValue}>{stats.totalOrders}</div>
                </div>
                <div className={`${styles.statCard} ${loading ? styles.loading : ''}`}>
                    <div className={styles.statTitle}>Revenue</div>
                    <div className={styles.statValue}>${stats.revenue.toLocaleString()}</div>
                </div>
            </div>

            <div className={styles.chartsSection}>
                <div className={styles.chartCard}>
                    <h2 className={styles.chartTitle}>User Growth</h2>
                    <div className={styles.chartPlaceholder}>
                        Chart will be implemented here
                    </div>
                </div>
                <div className={styles.chartCard}>
                    <h2 className={styles.chartTitle}>Revenue Overview</h2>
                    <div className={styles.chartPlaceholder}>
                        Chart will be implemented here
                    </div>
                </div>
            </div>

            <section className={styles.activitySection}>
                <h2 className={styles.chartTitle}>Recent Activity</h2>
                <ul className={styles.activityList}>
                    {stats.recentActivity.map(activity => (
                        <li key={activity.id} className={styles.activityItem}>
                            <div className={styles.activityIcon}>
                                {activity.icon}
                            </div>
                            <div className={styles.activityContent}>
                                <div className={styles.activityTitle}>{activity.title}</div>
                                <div className={styles.activityTime}>{activity.time}</div>
                                <div className={styles.activityStatus}>
                                    <span className={`${styles.statusBadge} ${styles[`status${activity.verified}`]}`}>
                                        {activity.verified ? 'Active ✅' : 'Inactive ❌'}
                                    </span>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </section>
        </div>
    );
};

export default AdminDashboard;